import Box from "@mui/material/Box";
import React from "react";
import { currentClient } from "../../config/clients";

const logoStyles = {
	backgroundImage: `url('${process.env.PUBLIC_URL}/assets/logos/${currentClient}.svg')`
};

const Logo = props => {
	return (
		<Box className="cmp-logo" sx={{ ...logoStyles }}>
			<span>Home</span>
		</Box>
	);
};

export default Logo;